import { useConversations } from '../conversation/useConversations'
import { useConversationUuid } from '../conversation/useConversationUuid'
import { useTaskObj } from './useTaskObj'

export function useTaskLastUpdated(): number | null {
  const taskObj = useTaskObj()
  const uuid = useConversationUuid()
  const { conversations } = useConversations()

  if (taskObj == null) {
    const conversation = conversations.find(c => c.uuid === uuid)
    // This is task_udpated_at is not the one we want to use
    // Fix it later. Another way to do this is to join the taskObj to
    // conversation object. So when toggling between tasks, we can get the
    // last updated time from the task object.
    return conversation?.task_updated_at || null
  }

  const items = taskObj.details.orderedStateResponses
  const resopnse = items[items.length - 1]
  return Number(resopnse!.createdTsSec) * 1000
}
